<template>
  <transition name="fade">
    <div v-if="show" class="stm-backdrop" @click.self="cerrar">
      <div class="stm-dialog">
        <div class="stm-header">
          <div class="stm-header-left">
            <div class="stm-icon-wrap">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M4 6h16M4 12h16M4 18h10" stroke="#01662E" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
            <div>
              <h3 class="stm-title">Mis tickets</h3>
              <p class="stm-subtitle">Estado y detalle de los tickets de soporte que has abierto.</p>
            </div>
          </div>
          <button class="stm-close" @click="cerrar" aria-label="Cerrar">&times;</button>
        </div>

        <div class="mtm-tabs">
          <button
            class="mtm-tab"
            :class="{ 'mtm-tab--active': tab === 'activos' }"
            @click="tab = 'activos'"
          >
            Activos <span class="mtm-tab-count">{{ activos.length }}</span>
          </button>
          <button
            class="mtm-tab"
            :class="{ 'mtm-tab--active': tab === 'resueltos' }"
            @click="tab = 'resueltos'"
          >
            Resueltos <span class="mtm-tab-count">{{ resueltos.length }}</span>
          </button>
        </div>

        <div class="stm-body mtm-body">
          <div v-if="cargando" class="mtm-empty">Cargando tus tickets…</div>
          <div v-else-if="error" class="stm-alert stm-alert--error">{{ error }}</div>
          <div v-else-if="listaActual.length === 0" class="mtm-empty">
            {{ tab === 'activos' ? 'No tienes tickets activos.' : 'Todavía no tienes tickets resueltos.' }}
          </div>
          <div v-else class="mtm-list">
            <ticket-list-item
              v-for="ticket in listaActual"
              :key="ticket.ticket_id"
              :ticket="ticket"
              :is-open="abiertoId === ticket.ticket_id"
              :start-rejecting="ticket.ticket_id === focusTicketId && initialAction === 'reject'"
              @toggle="toggleDetalle"
              @changed="reload"
            />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import TicketListItem from './TicketListItem.vue';

export default {
  name: 'MisTicketsModal',
  components: { TicketListItem },
  props: {
    show: { type: Boolean, default: false },
    focusTicketId: { type: String, default: '' },
    initialAction: { type: String, default: '' },
  },
  data() {
    return {
      tab: 'activos',
      abiertoId: null,
    };
  },
  computed: {
    cargando() { return this.$store.getters['tickets/misTicketsCargando']; },
    error() { return this.$store.getters['tickets/misTicketsError']; },
    activos() { return this.$store.getters['tickets/misTicketsActivos']; },
    resueltos() { return this.$store.getters['tickets/misTicketsResueltos']; },
    listaActual() { return this.tab === 'activos' ? this.activos : this.resueltos; },
  },
  watch: {
    show(val) {
      if (val) {
        this.tab = 'activos';
        this.abiertoId = this.focusTicketId || null;
        this.reload();
      }
    },
  },
  methods: {
    cerrar() {
      this.$emit('update:show', false);
    },
    reload() {
      return this.$store.dispatch('tickets/cargarMisTickets');
    },
    toggleDetalle(ticketId) {
      this.abiertoId = this.abiertoId === ticketId ? null : ticketId;
    },
  },
};
</script>

<style scoped>
.stm-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 25, 20, 0.55);
  backdrop-filter: blur(3px);
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.stm-dialog {
  background: #fff;
  border-radius: 18px;
  width: 100%;
  max-width: 620px;
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  box-shadow:
    0 30px 80px -10px rgba(0, 0, 0, 0.35),
    0 8px 20px -5px rgba(0, 0, 0, 0.08);
}
.stm-header {
  padding: 24px 28px 18px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #eef1ef;
}
.stm-header-left {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.stm-icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #e6f4ec 0%, #d3ecde 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.stm-title {
  margin: 0 0 3px;
  color: #01662E;
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.2px;
}
.stm-subtitle {
  margin: 0;
  color: #6b7280;
  font-size: 13px;
  line-height: 1.5;
}
.stm-close {
  background: #f4f5f4;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  font-size: 18px;
  line-height: 1;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  margin-left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, color 0.15s ease;
  flex-shrink: 0;
}
.stm-close:hover { background: #e9ebe9; color: #2d2d2d; }

.mtm-tabs {
  display: flex;
  gap: 4px;
  padding: 16px 28px 0;
  border-bottom: 1px solid #eef1ef;
}
.mtm-tab {
  background: none;
  border: none;
  padding: 8px 14px 12px;
  font-size: 13.5px;
  font-weight: 600;
  color: #9ca3af;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  display: flex;
  align-items: center;
  gap: 6px;
}
.mtm-tab--active {
  color: #01662E;
  border-bottom-color: #01662E;
}
.mtm-tab-count {
  background: #f4f5f4;
  color: inherit;
  font-size: 11px;
  border-radius: 10px;
  padding: 1px 7px;
}
.mtm-tab--active .mtm-tab-count {
  background: #e6f4ec;
}

.mtm-body {
  padding: 18px 28px 26px;
}
.mtm-empty {
  color: #9ca3af;
  font-size: 13.5px;
  text-align: center;
  padding: 30px 0;
}
.mtm-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.stm-alert {
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
}
.stm-alert--error {
  background: #fef2f2;
  color: #b91c1c;
  border-left: 3px solid #b91c1c;
}

.fade-enter-active, .fade-leave-active { transition: opacity 0.22s ease; }
.fade-enter, .fade-leave-to { opacity: 0; }
.fade-enter-active .stm-dialog, .fade-leave-active .stm-dialog {
  transition: transform 0.25s cubic-bezier(.2, .8, .2, 1);
}
.fade-enter .stm-dialog, .fade-leave-to .stm-dialog {
  transform: translateY(12px) scale(0.98);
}
</style>
